export const CJS_BLACK_FORMAT_ID = "black";
export const CJS_BLACK_EXTENSION = ".black";
export const CJS_BLACK_FOURCC = 0xB1ACF11E;
export const CJS_BLACK_VERSION = 1;
